import { render, staticRenderFns } from "./ModelosAtulizarModal.vue?vue&type=template&id=07b291cc"
import script from "./ModelosAtulizarModal.vue?vue&type=script&lang=js"
export * from "./ModelosAtulizarModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports